var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoverSkill2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 398,
    height: 80,
    viewBox: "0 0 398 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 61.9111L13.2667 58.9537C26.5333 56.1069 53.0667 50.0264 79.6 50.1093C106.133 50.0264 132.667 56.1069 159.2 53.0667C185.733 50.0264 212.267 38.4181 238.8 27.9982C265.333 17.6889 291.867 8.84444 318.4 4.42222C344.933 0 371.467 0 384.733 0H398V79.6H384.733C371.467 79.6 344.933 79.6 318.4 79.6C291.867 79.6 265.333 79.6 238.8 79.6C212.267 79.6 185.733 79.6 159.2 79.6C132.667 79.6 106.133 79.6 79.6 79.6C53.0667 79.6 26.5333 79.6 13.2667 79.6H0V61.9111Z",
    fill: "#DBC86A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverSkill2);
export default __webpack_public_path__ + "static/media/cover_skill2.d2bcda22dad8cab36278f3e979ca1349.svg";
export { ForwardRef as ReactComponent };